module.exports = __webpack_public_path__ + "img/three-two.63e721ec.png";